import { GradeYourSystem } from "../demos/GradeYourSystem";

export function GradePage() {
  return (
    <main className="wrap demo-page">
      <header className="demo-hero rise rise-1">
        <span className="eyebrow">Grade your PC · runs in your browser</span>
        <h1>Will KinSafe run well on your computer?</h1>
        <p>
          Find out before you install anything. This reads only what your
          browser already exposes — your graphics, memory, and CPU — grades your
          PC into the same tier the app uses, and shows the speed you can
          expect. Nothing is uploaded.
        </p>
      </header>

      <div className="rise rise-2">
        <GradeYourSystem />
      </div>
    </main>
  );
}
